import script from "./PandoraCarruselContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./PandoraCarruselContainer.vue?vue&type=script&setup=true&lang=js"

import "./PandoraCarruselContainer.vue?vue&type=style&index=0&id=3bdd42c2&lang=css"

const __exports__ = script;

export default __exports__